import { useTranslation } from "react-i18next";

import Button from "components/Button";

import { useWakeLockContext } from "context/WakeLock/useWakeLock";

import { useNewPatient } from "./useNewPatient";

export default function NewPatient() {
  const { t } = useTranslation();

  const { request } = useWakeLockContext();

  const { handleCreateNewSession } = useNewPatient();

  return (
    <div className="flex flex-col items-center justify-center gap-4 max-w-md w-full p-4">
      <p className="text-3xl font-bold">{t("home.dashboard.newPatient")}</p>
      <p className="text-general-gray-700">{t("home.dashboard.startNewSession")}</p>
      <Button
        className="w-full"
        onClick={() => {
          request();
          handleCreateNewSession();
        }}
      >
        {t("home.dashboard.start")}
      </Button>
    </div>
  );
}
